<!-- Maqueta: cabecera de `.sideNav` (logotipo, etiqueta con el nombre, "GENERAL" y separador).
     Los tres botones no estan en la maqueta: se conservan porque son la unica
     via a Inicio, Datos generales y Cerrar sesion. -->
<div class="branding" [routerLink]="['/inicio']">
    <img src="assets/Logo_azul.svg" alt="CNC Dental" class="app-logo">
    <div class="version">{{ version }}</div>
</div>

<span class="app-user-name">{{ profileName }}</span>

<div class="app-user-controls">
    <button mat-icon-button matTooltip="Inicio" routerLink="/inicio">
        <mat-icon>home</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Datos Generales" routerLink="/datos">
        <mat-icon>contact_page</mat-icon>
    </button>
    <ng-container *ngIf="mensajes && {n: noLeidas$ | async} as r">
        <button mat-icon-button matTooltip="Mensajes con CNC" aria-label="Mensajes"
                routerLink="/mensajes" [queryParams]="r.n ? {filtro: 'no-leidas'} : {}">
            <mat-icon [matBadge]="r.n" [matBadgeHidden]="!r.n" matBadgeColor="warn"
                      matBadgeSize="small" aria-hidden="false">mail</mat-icon>
        </button>
    </ng-container>
    <button mat-icon-button matTooltip="Cerrar sesión" (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
    </button>
</div>

<span class="side-nav-label">GENERAL</span>
<span class="separador"></span>
